<template>
  <div>
    <SidebarSearch @submit="submitForm" @clear="clearForm">
        <!-- <NxInputName @update:value="handleInputUpdate('nome', $event)" /> -->
        <NxInputClientWApp @update:value="handleInputUpdate('identifier', $event)" />
        <NxSelectPAAtendimento @update:value="handleSelectUpdate('deptoId', $event)" />
        <NxSelectResponsavelAtendimento @update:value="handleSelectUpdate('operatorId', $event)"/>
        <div>
          <!-- <NxSelectTipoFinalizacao @update:value="handleSelectUpdate('typeFinalization', $event)" /> -->
           <NxInputDateRangeAtendimento
           :limitToFifteenDays="true"
            label="Período de Referência:"
            @update:InitialValue="handleInputDateUpdate('startDate', $event, false)"
            @update:FinalValue="handleInputDateUpdate('endDate', $event, false)"
          />
        </div>
    </SidebarSearch>
  </div>
</template>

<script>
import SidebarSearch from '@/containers/layout/sidebars/SidebarSearch.vue'
import SearchCollapse from '@/containers/layout/sidebars/components/SearchCollapse.vue'
import { NxSelectPAAtendimento, NxSelectTipoFinalizacao, NxSelectResponsavelAtendimento } from '@/components/nexum/components/custom-selects/index.js'
import { NxInputName, NxInputClientWApp, NxInputDateRangeAtendimento } from '@/components/nexum/components/custom-inputs/index.js'
import toogleswitch from '@/components/UI/toogleSwitch/toogleSwitch.vue'

export default {
  name: 'SidebarQuadro',
  components: { SidebarSearch, SearchCollapse, NxSelectPAAtendimento, NxInputName, NxInputClientWApp, NxSelectTipoFinalizacao, toogleswitch, NxSelectResponsavelAtendimento, NxInputDateRangeAtendimento },
  data () {
    return {
      form: {
        nome: null,
        numeroPA: null,
        numeroTelefone: null,
        tipoFinalizacao: null,
        operatorId: null,
        status: 'Finalizado',
        startDate: null,
        endDate: null,
        identifier: null
      },
      formAberto: {
        nome: null,
        numeroPA: null,
        numeroTelefone: null,
        tipoFinalizacao: null,
        operatorId: null,
        status: 'Aberto',
        startDate: null,
        endDate: null,
        identifier: null
      }
    }
  },
  computed: {
  },
  methods: {
    submitForm () {
      this.$nextTick(() => {
        this.$emit('search', this.form, this.formAberto)
        this.$emit('update-pagination')
      })
    },
    clearForm () {
      this.$root.$emit('clearForm')
      this.$nextTick(() => {
        this.submitForm()
        this.page = 1
      })
    },
    clearField (field) {
      this.form[field] = null
      this.formAberto[field] = null
    },
    handleSelectUpdate (fieldName, selectedValue) {
      if (typeof selectedValue === 'string' || typeof selectedValue === 'number') {
        this.form[fieldName] = [selectedValue]
        this.formAberto[fieldName] = [selectedValue]
        return
      }
      if (Array.isArray(selectedValue) && !selectedValue.length) {
        this.clearField(fieldName)
        return
      }
      if (selectedValue) {
        this.form[fieldName] = Array.isArray(selectedValue) ? selectedValue.map(v => v.value) : [selectedValue.value]
        this.formAberto[fieldName] = Array.isArray(selectedValue) ? selectedValue.map(v => v.value) : [selectedValue.value]
      } else {
        this.clearField(fieldName)
      }
    },
    handleInputUpdate (fieldName, inputedValue) {
      if (inputedValue) {
        this.form[fieldName] = inputedValue.replace(/[^a-zA-Z0-9 ]/g, '')
        this.formAberto[fieldName] = inputedValue.replace(/[^a-zA-Z0-9 ]/g, '')
      } else {
        this.clearField(fieldName)
      }
    },
    handleInputDateUpdate (fieldName, inputedValue) {
      if (inputedValue) {
        this.form[fieldName] = new Date(inputedValue).toISOString()
        this.formAberto[fieldName] = new Date(inputedValue).toISOString()
      } else {
        this.clearField(fieldName)
      }
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/private/atendimento/indice_atendimento/search/SidebarIndiceAtendimento.vue